import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type DeleteCalendarEventRequest = InferRequestType<
  (typeof apiClient.calendar.events)[':eventId']['$delete']
>['param']
type DeleteCalendarEventResponse = InferResponseType<
  (typeof apiClient.calendar.events)[':eventId']['$delete']
>

export const useDeleteCalendarEvent = (
  options?: UseMutationOptions<
    DeleteCalendarEventResponse,
    Error,
    DeleteCalendarEventRequest
  >
) =>
  useMutation({
    mutationKey: ['delete-calendar-event'],
    mutationFn: (variables) => {
      return apiClient.calendar.events[':eventId']
        .$delete({
          param: { eventId: variables.eventId },
        })
        .then((r) => formatClientResponse(r))
    },
    ...options,
  })
